// Client for Backend/QP.Api's POST /api/KLevel/stage1/frontend — accepts the
// frontend's own Stage1Answers shape directly (mirrored 1:1 by
// FrontendStage1AnswersRequest), so no request mapping is needed here. The
// calculation itself lives only on the backend
// (Backend/QP.Api/Services/Stage1KLevelCalculator.cs) and only ever uses
// Stage 1 (patient self-report) + Self-Assessment answers — no physician or
// prosthetist stage is required for this preliminary estimate.
import type { Stage1Answers } from "@/lib/stage1Questionnaire";

export type KLevel = "K0" | "K1" | "K2" | "K3" | "K4";
export type Stage1Outcome = "Deferred" | "InsufficientData" | "Preliminary";

// Mirrors QP.Api.Models.Stage1Result's JSON casing (camelCase, ASP.NET Core's default).
export interface Stage1ResultApiResponse {
  outcome: Stage1Outcome;
  preliminaryKLevel: KLevel | null;
  deferReasons: string[];
  flags: string[];
  suggestions: string[];
  disclaimer: string;
}

export async function fetchStage1KLevel(
  answers: Stage1Answers,
): Promise<Stage1ResultApiResponse> {
  // Lowercase to match API Gateway's route exactly — ASP.NET Core routing is
  // case-insensitive locally, but API Gateway path matching is not.
  const response = await fetch("/api/klevel/stage1/frontend", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(answers),
  });

  if (!response.ok) {
    throw new Error(`K-Level calculation failed (${response.status})`);
  }

  return response.json();
}
